import { ButtonBase, CircularProgress, Divider } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    color: #101d40;
    font-size: 20px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    font-family: Sora, sans-serif;
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);
    svg {
      color: #4f4f4f;
      font-size: 22px;
    }
    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 300px;
  overflow-y: auto;

  scrollbar-width: thin;
  scrollbar-color: black transparent;

  h2 {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: var(--color-navy-blue);
  }

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a1a1a1;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }

  .scheduling {
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    > div {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .seleted__day {
      .react-datepicker {
        border: 2px solid var(--color-gray-900);
      }

      .react-datepicker__header {
        background: transparent;
        border-bottom: 2px solid var(--color-gray-900);
      }

      .react-datepicker__day-name {
        color: var(--color-red);
        font-family: Sora;
        font-weight: 600;
        font-size: 12px;
      }

      .react-datepicker__current-month {
        color: var(--color-blue);
      }

      .react-datepicker__triangle {
        border-bottom-color: var(--color-gray-900);
        left: 100px !important;
      }

      .react-datepicker__triangle::before {
        display: none;
      }

      .react-datepicker__navigation--next {
        border-left-color: var(--color-blue);
      }

      .react-datepicker__navigation--previous {
        border-right-color: var(--color-blue);
      }

      .react-datepicker__current-month {
        font-family: Sora;
        font-size: 16px;
        text-transform: uppercase;
        color: var(--color-blue);
      }

      .react-datepicker__day {
        color: var(--color-navy-blue);
        font-family: Sora;
        font-weight: 500;
      }

      .react-datepicker__day--disabled {
        cursor: default;
        color: var(--color-gray-800);
      }

      .react-datepicker__day--selected {
        background-color: var(--color-blue);
        color: #fff;
      }

      .react-datepicker__day--keyboard-selected {
        background-color: transparent;
      }
    }

    .hours__option {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 8px 0px;
    }
  }

  .PrivateTabIndicator-colorSecondary-52,
  .PrivateTabIndicator-colorSecondary-41 {
    background-color: var(--color-blue);
  }

  .MuiTab-textColorSecondary {
    font-family: 'Sora', sans-serif;
    font-weight: bold;
    color: var(--color-gray-800);
  }

  .MuiTab-textColorSecondary.Mui-selected {
    color: var(--color-blue);
  }

  .MuiContainer-root {
    padding: 0;
  }

  .payment,
  .coupon {
    min-height: 200px;
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    h2 {
      text-align: center;
    }
  }

  .css-26l3qy-menu {
    z-index: 3000;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  user-select: none;
`;

export const CustomCircularProgress = styled(CircularProgress)`
  color: var(--color-blue);
`;

export const Item = styled(ButtonBase)`
  padding: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: var(--color-navy-blue);
  font-family: Sora, sans-serif;

  .MuiRadio-colorSecondary.Mui-checked {
    color: var(--color-blue) !important;
  }

  .MuiIconButton-colorSecondary:hover {
    background-color: #329bfc1a;
  }

  .PrivateSwitchBase-root-39 {
    padding: 0;
  }

  .informations {
    display: -webkit-flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
    text-align: start;
    gap: 8px;
  }

  p {
    font-size: 16px;
    line-height: 20px;
    user-select: none;
    color: var(--color-navy-blue);
    font-family: Sora, sans-serif;
  }
`;

export const CustomDivider = styled(Divider)`
  width: 100%;
  background: var(--color-gray-900);
`;

export const OptionItem = styled.button<{ selected?: boolean }>`
  border: 2px solid var(--color-gray-900);
  border-radius: 5px;
  padding: 4px;
  user-select: none;
  cursor: pointer;
  background-color: transparent;
  width: min-content;
  height: min-content;

  p {
    font-weight: 600;
  }

  ${(p) =>
    p.selected &&
    css`
      border-color: var(--color-blue);

      p {
        color: var(--color-blue);
      }
    `}
`;

export const CustomCaledar = styled.button`
  border: 2px solid var(--color-gray-900);
  border-radius: 5px;
  padding: 8px;
  user-select: none;
  cursor: pointer;
  background-color: transparent;
  width: auto;
  height: min-content;
  display: flex;
  gap: 4px;
  align-items: center;
  border-color: var(--color-blue);

  svg {
    color: var(--color-blue);
  }
`;
